// src/utils/utils.js

export const maskPhone = (phone) => {
  if (!phone) return '';
  const hasAt = phone.startsWith('@');
  const cleanPhone = hasAt ? phone.slice(1) : phone;
  if (cleanPhone.length <= 4) return phone;
  const masked = 'x'.repeat(cleanPhone.length - 4) + cleanPhone.slice(-4);
  return hasAt ? `@${masked}` : masked;
};

export const maskName = (name) => {
  if (!name) return '';
  return name[0] + '.';
};
